import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import { MediaQuery as MQ } from '../media-query';

class Component extends BaseComponent {
    constructor() {
        super();

        this.setState({
            links: [
                {
                    href: '/daily-horoscope',
                    label: 'Daily Horoscope',
                    slug: 'horoscope',
                },
                {
                    href: '/daily-love-horoscope',
                    label: 'Daily Love Horoscope',
                    slug: 'love',
                },
                {
                    href: '/daily-tarot-card',
                    label: 'Tarot Card of the Day',
                    slug: 'tarot',
                },
                {
                    href: '/daily-hexagram',
                    label: 'Hexagram of the Day',
                    slug: 'hexagram',
                },
                {
                    href: '/daily-number',
                    label: 'Number of the Day',
                    slug: 'number',
                },
                {
                    href: '/daily-psychic-tip',
                    label: 'Psychic Tip of the Day',
                    slug: 'psychic',
                },
            ],
        });
    }

    render() {
        return (
            <mobile-daily-links>
                {this.state.links.map(this.renderLink)}
            </mobile-daily-links>
        );
    }

    renderLink = ({ href, label, slug}) => {
        if (MQ.isMobile() && slug == 'psychic') {
            return null;
        }

        this.trackImpression(label);

        return (
            <a
              class='mobile-daily-links'
              href={href}
              onClick={() => this.trackClick(label)}
            >
                <img
                  src={`https://gfx.tarot.com/images/daily-pages/daily-icons/${slug}.svg`}
                  alt={label}
                />
                {label}
            </a>
        );
    }

    trackImpression = (label) => {
        this.props.trackEvent([ 'Daily Page Mini Nav', `${this.props.logged_in ? 'LI' : 'LO'} Impression`, label ]);
    }

    trackClick = (label) => {
        this.props.trackEvent([ 'Daily Page Mini Nav', `${this.props.logged_in ? 'LI' : 'LO'} Click`, label ]);
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/mobile-daily-links.js